import { CaretDown } from "@phosphor-icons/react";
import { clsx } from "clsx";
import { useState } from "react";

import AimfoxAvatar from "common/components/ui/AimfoxAvatar";
import useCustomer from "common/datahooks/useCustomer";
import ExtraNavItems from "common/layouts/WorkspaceLayout/ExtraNavItems";

export default function MobileProfilePopup() {
  const [isExpanded, setIsExpanded] = useState(false);
  const { customerInfo } = useCustomer();
  const { first_name: firstName, last_name: lastName, email } = customerInfo;

  return (
    <div className="">
      <div
        className={clsx(
          " p-4 rounded-7xl mt-auto flex absolute bottom-2 inset-x-2 flex-col transition-[shadow,background] overflow-hidden duration-500",
          isExpanded
            ? "shadow-[0_0_25px_0_rgba(17,24,39,0.10)] bg-white"
            : "bg-white/50",
        )}
      >
        <button
          className="flex items-center gap-x-3"
          type="button"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <AimfoxAvatar firstName={firstName} lastName={lastName} size="lg" />
          <div className="flex flex-col gap-y-0.5 flex-1">
            <span className="text-lg-bold text-left">
              {firstName} {lastName}
            </span>
            <span className="text-black-500 text-sm-medium text-left">
              {email}
            </span>
          </div>
          <CaretDown
            className={clsx(
              "size-5 m-2.5 text-black-500 transition-transform",
              isExpanded && "rotate-180",
            )}
          />
        </button>
        <div
          className={clsx(
            "grid transition-[grid,padding] overflow-hidden ease-in-out duration-300",
            isExpanded ? "grid-rows-[1fr] pt-2" : "grid-rows-[0fr] pt-0",
          )}
        >
          <div className="flex flex-col h-full overflow-hidden">
            <ExtraNavItems isExpanded />
          </div>
        </div>
      </div>
    </div>
  );
}
